/// <reference types="./vite-env" />
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { syncQueueService } from './services/syncQueue';

// Инициализируем синхронизацию при старте приложения
syncQueueService.sync().catch(console.error);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

